import { FeedbackData } from "src/classes/models/interview";
import ScoreBadge from "./ScoreBadge";

interface IFeedbackCard {
  feedback: FeedbackData;
}

const FeedbackCard = ({ feedback }: IFeedbackCard) => {
  return (
    <div className="bg-white rounded-xl overflow-hidden ">
      <div className="flex items-center justify-between px-4 py-6 border-l-odfblue border-l-4 border-b-[#ccc] border-b-[1px] ">
        <p className="font-poppins text-xl font-semibold ">{feedback.title}</p>
        <ScoreBadge feedback={feedback} />
      </div>

      <ul className="w-full rounded-lg bg-white p-4 pl-8 font-poppins text-sm mt-3 whitespace-pre-line leading-[32px]">
        {feedback.summary.map((f) => (
          <li key={f} className="list-disc">
            {f}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FeedbackCard;
